import { NgFor, NgTemplateOutlet } from '@angular/common';
import { Component, Input, TemplateRef } from '@angular/core';
import { IconModule } from '@vg-constellation/angular-20/icon';
import { TileComponent } from '../tile.component';

@Component({
    selector: 'zci-single-status-list-tile',
    templateUrl: './single-status-list-tile.component.html',
    styleUrls: ['./single-status-list-tile.component.scss'],
    imports: [
        NgFor,
        IconModule,
        TileComponent,
        NgTemplateOutlet
    ],
})
export class SingleStatusListTileComponent {
    @Input() items: string[];

    /**
     * Icon displayed next to every item to provide visual feedback on the status of the items.
     */
    @Input() statusIcon: TemplateRef<unknown>;
}
